import getMessage from 'src/background/utils/i18n.utils';
import { goBack, navigateTo, resetNav, } from '@popup/multichain/actions/navigation.actions';
import React from 'react';
import { connect } from 'react-redux';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
const PageTitle = ({ title, titleParams, skipTitleTranslation, isBackButtonEnabled, isCloseButtonDisabled, rightAction, onBackAdditional, onCloseAdditional, goBack, navigateTo, canGoBack, resetNav, showDetachWindowOption, }) => {
    const handleBackButtonClick = () => {
        if (onBackAdditional)
            onBackAdditional();
        if (isBackButtonEnabled) {
            goBack();
        }
    };
    const handleCloseButtonClick = () => {
        if (onCloseAdditional) {
            onCloseAdditional();
        }
        resetNav();
    };
    const handleRightActionButtonClick = () => {
        if (rightAction) {
            rightAction.callback();
        }
    };
    const handleDetachWindow = () => {
        chrome.tabs.create({
            url: `detached_window.html`,
        });
    };
    return (React.createElement("div", { className: "title-section" },
        isBackButtonEnabled && canGoBack && (React.createElement(SVGIcon, { dataTestId: "arrow-back-icon", onClick: handleBackButtonClick, icon: SVGIcons.TOP_BAR_BACK_BTN, className: "icon-button" })),
        React.createElement("div", { className: "title" }, skipTitleTranslation
            ? title
            : getMessage(title, titleParams)),
        rightAction && (React.createElement(SVGIcon, { onClick: handleRightActionButtonClick, icon: rightAction.icon, className: `icon-button ${rightAction.className}` })),
        !rightAction && !isCloseButtonDisabled && (React.createElement(SVGIcon, { dataTestId: "icon-close-page", onClick: handleCloseButtonClick, icon: SVGIcons.TOP_BAR_CLOSE_BTN }))));
};
const mapStateToProps = (state) => {
    return {
        canGoBack: state.navigation.stack.length > 1,
    };
};
const connector = connect(mapStateToProps, { goBack, navigateTo, resetNav });
export const PageTitleComponent = connector(PageTitle);
